// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type SvgProps = {
    width?: number;
    height?: number;
}

const AnnouncementBannerSVG = (props: SvgProps) => (
    <svg
        width={props.width ? props.width.toString() : '172'}
        height={props.height ? props.height.toString() : '220'}
        viewBox='0 0 172 220'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M171.521 59.137C171.521 53.3935 165.803 47.6499 160.086 47.6499H11.4347C5.71737 47.6499 0 53.3935 0 59.137V168.33H171.521V59.137Z'
            fill='#2D3039'
        />
        <path
            d='M0 168.33V179.817C0 185.561 5.71737 191.304 11.4347 191.304H160.086C165.803 191.304 171.521 185.561 171.521 179.817V168.33H0Z'
            fill='#DDDFE4'
        />
        <path
            d='M62.8914 197.026C62.8914 208.513 51.4567 208.513 40.0654 208.513H131.543C120.108 208.513 108.717 208.513 108.717 197.026V191.26H62.9784L62.8914 197.026Z'
            fill='#C6C9D2'
        />
        <path
            d='M160.086 59.1807H11.4346V156.821H160.086V59.1807Z'
            fill='white'
        />
        <g clipPath='url(#clip0)'>
            <rect
                x='10.625'
                y='58.8018'
                width='149.764'
                height='98.341'
                rx='4'
                fill='white'
            />
            <rect
                x='10.625'
                y='58.8018'
                width='50.0757'
                height='98.341'
                fill='#1E325C'
            />
            <ellipse
                cx='19.1333'
                cy='67.8081'
                rx='4.61863'
                ry='4.62495'
                fill='white'
                fillOpacity='0.16'
            />
            <rect
                x='26.6689'
                y='64.6436'
                width='22.3639'
                height='2.43418'
                rx='1.21709'
                fill='white'
                fillOpacity='0.32'
            />
            <rect
                x='26.6689'
                y='69.5122'
                width='14.5851'
                height='1.94735'
                rx='0.973675'
                fill='white'
                fillOpacity='0.32'
            />
            <rect
                x='15.4863'
                y='78.7622'
                width='14.5851'
                height='1.94735'
                rx='0.973675'
                fill='white'
                fillOpacity='0.32'
            />
            <rect
                x='15.4863'
                y='143.511'
                width='14.5851'
                height='1.94733'
                rx='0.973667'
                fill='white'
                fillOpacity='0.32'
            />
            <ellipse
                cx='17.6741'
                cy='86.7948'
                rx='2.18777'
                ry='2.19076'
                fill='white'
                fillOpacity='0.16'
            />
            <rect
                x='22.7783'
                y='86.0649'
                width='28.198'
                height='1.94735'
                rx='0.973673'
                fill='white'
                fillOpacity='0.32'
            />
            <ellipse
                cx='17.6741'
                cy='111.624'
                rx='2.18777'
                ry='2.19076'
                fill='white'
                fillOpacity='0.16'
            />
            <rect
                x='22.7783'
                y='110.894'
                width='28.198'
                height='1.94733'
                rx='0.973667'
                fill='white'
                fillOpacity='0.32'
            />
            <ellipse
                cx='17.6741'
                cy='95.0711'
                rx='2.18777'
                ry='2.19077'
                fill='white'
                fillOpacity='0.16'
            />
            <rect
                x='22.7783'
                y='94.3413'
                width='24.3086'
                height='1.94736'
                rx='0.973679'
                fill='white'
                fillOpacity='0.32'
            />
            <ellipse
                cx='17.6741'
                cy='119.9'
                rx='2.18777'
                ry='2.19077'
                fill='white'
                fillOpacity='0.16'
            />
            <rect
                x='22.7783'
                y='119.17'
                width='24.3086'
                height='1.94735'
                rx='0.973677'
                fill='white'
                fillOpacity='0.32'
            />
            <ellipse
                cx='17.6741'
                cy='103.348'
                rx='2.18777'
                ry='2.19077'
                fill='white'
                fillOpacity='0.16'
            />
            <rect
                x='22.7783'
                y='102.618'
                width='32.0873'
                height='1.94735'
                rx='0.973675'
                fill='white'
                fillOpacity='0.32'
            />
            <ellipse
                cx='17.6741'
                cy='128.177'
                rx='2.18777'
                ry='2.19076'
                fill='white'
                fillOpacity='0.16'
            />
            <rect
                x='22.7783'
                y='127.447'
                width='32.0873'
                height='1.94734'
                rx='0.973671'
                fill='white'
                fillOpacity='0.32'
            />
            <ellipse
                cx='17.6741'
                cy='151.544'
                rx='2.18777'
                ry='2.19077'
                fill='white'
                fillOpacity='0.16'
            />
            <rect
                x='22.7783'
                y='150.814'
                width='32.0873'
                height='1.94733'
                rx='0.973667'
                fill='white'
                fillOpacity='0.32'
            />
            <ellipse
                cx='17.6741'
                cy='136.452'
                rx='2.18777'
                ry='2.19077'
                fill='white'
                fillOpacity='0.16'
            />
            <rect
                x='22.7783'
                y='135.722'
                width='21.3916'
                height='1.94734'
                rx='0.973671'
                fill='white'
                fillOpacity='0.32'
            />
            <rect
                x='60.7012'
                y='72.4331'
                width='91.4003'
                height='27.2628'
                rx='4'
                fill='white'
            />
            <ellipse
                cx='69.8318'
                cy='81.5772'
                rx='4.14719'
                ry='4.15286'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='77.666'
                y='78.0391'
                width='19.6607'
                height='1.84571'
                rx='0.922856'
                fill='#3D3C40'
                fillOpacity='0.16'
            />
            <rect
                x='77.7178'
                y='82.1699'
                width='59.3129'
                height='1.46051'
                rx='0.730256'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='77.7178'
                y='85.5781'
                width='48.6172'
                height='1.4605'
                rx='0.730252'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='77.7178'
                y='88.4985'
                width='66.6055'
                height='1.46051'
                rx='0.730255'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='77.7178'
                y='91.9062'
                width='35.0043'
                height='1.46052'
                rx='0.730259'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='60.7012'
                y='96.2881'
                width='91.4003'
                height='27.2629'
                rx='4'
                fill='white'
            />
            <ellipse
                cx='69.8318'
                cy='105.432'
                rx='4.14719'
                ry='4.15285'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='77.666'
                y='101.894'
                width='19.6607'
                height='1.84571'
                rx='0.922857'
                fill='#3D3C40'
                fillOpacity='0.16'
            />
            <rect
                x='77.7178'
                y='106.025'
                width='59.3129'
                height='1.46051'
                rx='0.730253'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='77.7178'
                y='109.433'
                width='48.6172'
                height='1.46051'
                rx='0.730253'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='77.7178'
                y='112.354'
                width='66.6055'
                height='1.46053'
                rx='0.730263'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='77.7178'
                y='115.761'
                width='35.0043'
                height='1.46051'
                rx='0.730255'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='60.7012'
                y='122.091'
                width='91.4003'
                height='27.2628'
                rx='4'
                fill='white'
            />
            <ellipse
                cx='69.8318'
                cy='131.235'
                rx='4.14719'
                ry='4.15287'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='77.666'
                y='127.697'
                width='19.6607'
                height='1.84569'
                rx='0.922844'
                fill='#3D3C40'
                fillOpacity='0.16'
            />
            <rect
                x='77.7178'
                y='131.828'
                width='59.3129'
                height='1.46053'
                rx='0.730263'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='77.7178'
                y='135.235'
                width='48.6172'
                height='1.46053'
                rx='0.730263'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='77.7178'
                y='138.156'
                width='66.6055'
                height='1.4605'
                rx='0.730251'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='77.7178'
                y='141.564'
                width='35.0043'
                height='1.46049'
                rx='0.730247'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='62.1592'
                y='60.2627'
                width='115.709'
                height='14.892'
                rx='4'
                fill='white'
            />
            <ellipse
                cx='92.084'
                cy='66.6189'
                rx='1.26953'
                ry='1.27127'
                fill='#3D3C40'
                fillOpacity='0.16'
            />
            <ellipse
                cx='131.621'
                cy='67.7092'
                rx='1.63225'
                ry='1.63449'
                fill='#3D3C40'
                fillOpacity='0.16'
            />
            <ellipse
                cx='97.5254'
                cy='66.6189'
                rx='1.26952'
                ry='1.27127'
                fill='#3D3C40'
                fillOpacity='0.16'
            />
            <rect
                x='67.2373'
                y='65.7104'
                width='21.038'
                height='1.45288'
                rx='0.726438'
                fill='#3D3C40'
                fillOpacity='0.24'
            />
            <rect
                x='135.792'
                y='66.0747'
                width='27.2043'
                height='3.26898'
                rx='1.63449'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <rect
                x='76.668'
                y='69.3428'
                width='32.2824'
                height='0.726439'
                rx='0.36322'
                fill='#3D3C40'
                fillOpacity='0.08'
            />
            <ellipse
                cx='68.3255'
                cy='69.7064'
                rx='1.08817'
                ry='1.08966'
                fill='#3D3C40'
                fillOpacity='0.16'
            />
            <ellipse
                cx='72.678'
                cy='69.7064'
                rx='1.08817'
                ry='1.08966'
                fill='#3D3C40'
                fillOpacity='0.16'
            />
        </g>
        <rect
            x='10.125'
            y='58.3018'
            width='150.764'
            height='99.341'
            rx='4.5'
            stroke='#3F4350'
            strokeOpacity='0.16'
        />
        <path
            d='M85.76 176.749C86.3254 176.749 86.8781 176.917 87.3482 177.233C87.8183 177.548 88.1847 177.997 88.401 178.521C88.6174 179.046 88.674 179.623 88.5637 180.181C88.4534 180.738 88.1812 181.249 87.7814 181.651C87.3816 182.053 86.8722 182.326 86.3177 182.437C85.7631 182.548 85.1884 182.491 84.666 182.274C84.1437 182.056 83.6972 181.688 83.3831 181.216C83.069 180.744 82.9014 180.188 82.9014 179.62C82.9014 178.859 83.2025 178.128 83.7386 177.59C84.2747 177.051 85.0018 176.749 85.76 176.749Z'
            fill='#BABEC9'
        />
        <path
            d='M131.499 208.513H40.0215V220H131.499V208.513Z'
            fill='#A4A9B7'
        />
        <rect
            opacity='0.92'
            x='11'
            y='58.5'
            width='149.5'
            height='42'
            fill='#579EFF'
        />
        <path
            d='M29 66.9919C27.192 66.9919 25.512 67.4479 23.96 68.3599C22.456 69.2559 21.256 70.4559 20.36 71.9599C19.448 73.5119 18.992 75.1919 18.992 76.9999C18.992 78.8079 19.448 80.4879 20.36 82.0399C21.256 83.5439 22.456 84.7439 23.96 85.6399C25.512 86.5519 27.192 87.0079 29 87.0079C30.808 87.0079 32.488 86.5519 34.04 85.6399C35.544 84.7439 36.744 83.5439 37.64 82.0399C38.552 80.4879 39.008 78.8079 39.008 76.9999C39.008 75.1919 38.552 73.5119 37.64 71.9599C36.744 70.4559 35.544 69.2559 34.04 68.3599C32.488 67.4479 30.808 66.9919 29 66.9919ZM29 84.9919C27.56 84.9919 26.216 84.6239 24.968 83.8879C23.768 83.1839 22.816 82.2319 22.112 81.0319C21.376 79.7839 21.008 78.4399 21.008 76.9999C21.008 75.5599 21.376 74.2159 22.112 72.9679C22.816 71.7679 23.768 70.8159 24.968 70.1119C26.216 69.3759 27.56 69.0079 29 69.0079C30.44 69.0079 31.784 69.3759 33.032 70.1119C34.232 70.8159 35.184 71.7679 35.888 72.9679C36.624 74.2159 36.992 75.5599 36.992 76.9999C36.992 78.4399 36.624 79.7839 35.888 81.0319C35.184 82.2319 34.232 83.1839 33.032 83.8879C31.784 84.6239 30.44 84.9919 29 84.9919ZM29.504 78.0079H28.496L27.992 72.0079H30.008L29.504 78.0079ZM30.008 81.0079C30.008 81.2799 29.904 81.5119 29.696 81.7039C29.504 81.8959 29.272 81.9919 29 81.9919C28.728 81.9919 28.488 81.8959 28.28 81.7039C28.088 81.5119 27.992 81.2799 27.992 81.0079C27.992 80.7359 28.088 80.5039 28.28 80.3119C28.488 80.1039 28.728 79.9999 29 79.9999C29.272 79.9999 29.504 80.1039 29.696 80.3119C29.904 80.5039 30.008 80.7359 30.008 81.0079Z'
            fill='white'
        />
        <rect
            x='47'
            y='69.5'
            width='32'
            height='3'
            rx='1.5'
            fill='white'
        />
        <rect
            x='47'
            y='75.5'
            width='88'
            height='3'
            rx='1.5'
            fill='white'
        />
        <rect
            x='47'
            y='81.5'
            width='74'
            height='3'
            rx='1.5'
            fill='white'
        />
        <defs>
            <clipPath id='clip0'>
                <rect
                    x='10.625'
                    y='58.8018'
                    width='149.764'
                    height='98.341'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </svg>
);

export default AnnouncementBannerSVG;
